import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { FaceProvider } from "@/contexts/FaceContext";

import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import { AppShell } from "@/components/AppShell";
import Home from "@/pages/Home";
import Attendance from "@/pages/Attendance";
import Team from "@/pages/Team";
import Reports from "@/pages/Reports";
import More from "@/pages/More";
import LeaveManager from "@/pages/LeaveManager";
import Holidays from "@/pages/Holidays";
import Regularization from "@/pages/Regularization";
import Backup from "@/pages/Backup";
import SettingsPage from "@/pages/Settings";
import Kiosk from "@/pages/Kiosk";
import AuditLog from "@/pages/AuditLog";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[100svh] flex items-center justify-center" style={{ background: "#0A0D14" }}>
        <div className="w-10 h-10 rounded-full border-2 animate-spin" style={{ borderColor: "#1E2640", borderTopColor: "#4F8EF7" }} />
      </div>
    );
  }
  if (!user) return <Navigate to="/welcome" replace />;
  return children;
}

// Clears any leftover body scroll-lock styles (vaul/radix) on every route change
function ScrollUnlock() {
  const location = useLocation();
  useEffect(() => {
    const b = document.body;
    // clear ALL leftover inline styles (position, overflow, pointer-events, padding…)
    b.removeAttribute("style");
    document.documentElement.style.overflow = "";
  }, [location.pathname]);
  return null;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/welcome" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><AppShell /></Protected>}>
        <Route path="/" element={<Home />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/team" element={<Team />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/more" element={<More />} />
      </Route>
      <Route path="/leaves" element={<Protected><LeaveManager /></Protected>} />
      <Route path="/holidays" element={<Protected><Holidays /></Protected>} />
      <Route path="/regularization" element={<Protected><Regularization /></Protected>} />
      <Route path="/backup" element={<Protected><Backup /></Protected>} />
      <Route path="/kiosk" element={<Protected><Kiosk /></Protected>} />
      <Route path="/audit-log" element={<Protected><AuditLog /></Protected>} />
      <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <FaceProvider>
            <ScrollUnlock />
            <AppRouter />
            <Toaster position="top-center" theme="dark" />
          </FaceProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
